import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LogoContainer from "./LogoContainer";
import { enqueueSnackbar } from "notistack";
import { Button, useMediaQuery } from "@mui/material";
import { two_Step_verification } from "../../../DAL/auth/auth";
import { useAdminContext } from "../../../hooks/UseAdminContext";
import DashboardHeader from "../../headers/DashboardHeader";

export default function TwoStepWithCalidation() {
  const [selectedMethod, setSelectedMethod] = useState("email");
  const [loading, setLoading] = useState(false);
  const { userInfo } = useAdminContext();
  const { state } = useLocation();

  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleSubmit = async (e) => {
    e.preventDefault();
    let selectedValue =
      selectedMethod === "email"
        ? userInfo?.user_info?.email
        : userInfo?.contact_number;
    setLoading(true);
    const data = {
      source_type: selectedMethod,
      source: selectedValue,
      login_by: state?.is_login ? "login" : "sign_up",
    };

    if (selectedMethod === "phone_number") {
      data.email = userInfo?.user_info?.email;
    }

    const response = await two_Step_verification(data);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setLoading(false);
      navigate(`/verification-otp/${selectedMethod}`, {
        state: state,
      });
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
  };

  useEffect(() => {
    let type_set = localStorage.getItem("type");
    if (type_set) {
      setSelectedMethod(type_set);
    }
  }, []);

  return (
    <div className="header-container">
      <DashboardHeader />
      <div className={`${isMobile ? "" : "pageContainer"}`}>
        <LogoContainer />
        <div className={`${isMobile ? "new-form" : "form-layout"}`}>
          <div style={styles.scrollableFormWrapper}>
            <div style={styles.formContainer}>
              <div style={styles.formContent}>
                <div style={{ maxWidth: "600px", margin: "0 auto" }}>
                  <h2 style={{ marginBottom: "16px" }}>
                    Two-Step Verification Method
                  </h2>
                  <p style={{ marginBottom: "24px" }}>
                    What is your preferred method to receive your verification
                    code?
                  </p>

                  <form onSubmit={handleSubmit}>
                    <div
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "16px",
                        marginBottom: "12px",
                        backgroundColor:
                          selectedMethod === "phone_number"
                            ? "#f0f7ff"
                            : "white",
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectedMethod("phone_number")}
                    >
                      <div
                        style={{ display: "flex", alignItems: "flex-start" }}
                      >
                        <input
                          type="radio"
                          name="verificationMethod"
                          value="sms"
                          checked={selectedMethod === "phone_number"}
                          onChange={() => {}}
                          style={{ marginRight: "12px", marginTop: "3px" }}
                        />
                        <div>
                          <div
                            style={{ fontWeight: "bold", marginBottom: "4px" }}
                          >
                            SMS Text Message
                          </div>
                          <div style={{ color: "#666", fontSize: "14px" }}>
                            {userInfo?.contact_number}
                          </div>
                          {!state?.is_login && (
                            <div
                              style={{
                                marginTop: "8px",
                                fontSize: "13px",
                                color: "#444",
                              }}
                            >
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    marginRight: "8px",
                                    marginTop: "2px",
                                  }}
                                  required={selectedMethod === "phone_number"}
                                />
                                <span>
                                  By checking this box you agree to receive text
                                  messages from Little Haiti Global.
                                  <br />
                                  Reply STOP to opt out; Reply HELP for help.
                                  <br />
                                  Message frequency varies. Message and data
                                  rates may apply.
                                  <br />
                                  View our{" "}
                                  <a
                                    href="/privacypolicy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#0071bc",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    Privacy Policy
                                  </a>
                                  .
                                </span>
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "16px",
                        marginBottom: "24px",
                        backgroundColor:
                          selectedMethod === "email" ? "#f0f7ff" : "white",
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectedMethod("email")}
                    >
                      <div
                        style={{ display: "flex", alignItems: "flex-start" }}
                      >
                        <input
                          type="radio"
                          name="verificationMethod"
                          value="email"
                          checked={selectedMethod === "email"}
                          style={{ marginRight: "12px", marginTop: "3px" }}
                        />
                        <div>
                          <div
                            style={{ fontWeight: "bold", marginBottom: "4px" }}
                          >
                            Email
                          </div>
                          <div style={{ color: "#666", fontSize: "14px" }}>
                            {userInfo?.user_info?.email}
                          </div>
                        </div>
                      </div>
                    </div>

                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send"}
                    </Button>
                  </form>
                  <div className="mt-3 text-end">
                    <Button
                      className="w-100"
                      onClick={() => navigate("/login")}
                    >
                      Back to Login
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  logoImage: {
    width: "100%",
    maxWidth: "500px",
    height: "auto",
    marginBottom: "30px",
    objectFit: "contain",
  },
  logoTitle: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
  },
  logoSubtitle: {
    fontSize: "1.5rem",
    color: "#555",
    fontWeight: "normal",
  },
  formContainer: {
    flex: 1.4, // Increased from 1 to make right side wider
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
  },
  formContent: {
    width: "100%",
    maxWidth: "400px",
  },
  signInTitle: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    marginBottom: "30px",
    color: "#333",
  },
  form: {
    width: "100%",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#333",
  },
  input: {
    width: "100%",
    padding: "12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "16px",
    boxSizing: "border-box",
  },
  visibilityToggle: {
    position: "absolute",
    right: "10px",
    top: "38px",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#666",
  },
  forgotPasswordContainer: {
    textAlign: "right",
    marginBottom: "20px",
  },
  forgotPasswordLink: {
    color: "#0066cc",
    textDecoration: "none",
    fontSize: "14px",
  },
  submitButton: {
    width: "100%",
    padding: "14px",
    backgroundColor: "#006F32",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    marginBottom: "20px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#005999",
    },
  },
  signUpContainer: {
    textAlign: "center",
    marginTop: "20px",
  },
  signUpText: {
    color: "#555",
    fontSize: "14px",
    marginBottom: "0", // remove spacing between lines
  },

  signUpLink: {
    color: "#0071bc",
    textDecoration: "none",
    fontWeight: "bold",
    marginLeft: "5px",
  },
  scrollableFormWrapper: {
    width: "100%",
    maxWidth: "400px",
    maxHeight: "90vh",
    overflowY: "auto",
    paddingRight: "10px",

    /* Hide scrollbar for Webkit browsers (Chrome, Safari) */
    WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // Internet Explorer 10+

    // Hide scrollbar in Webkit-based browsers
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
};
